import { Outlet } from "react-router-dom";
import { DesktopSidebar } from "./DesktopSidebar";

/**
 * Il guscio dell'app: sidebar su desktop, nient'altro.
 *
 * La barra in basso (Chat/Storico/Impostazioni) non esiste piu': era nascosta
 * sulla chat e compariva solo su Storico e Impostazioni, quindi la si
 * incontrava per caso e sembrava un'altra app (Davide, 26/08: «non la vedevo
 * dalle prime versioni, ha senso?»). No: si naviga dal menu laterale, e le
 * pagine interne hanno la freccia per tornare in chat.
 */
export function AppShell() {
  return (
    <div className="flex h-dvh min-h-0 w-full overflow-hidden bg-background text-foreground">
      <DesktopSidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <main className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
